import { plans } from 'shared/constants';

export default function useFeatureAccess(plan, subscriptionPastDue, betaPhaseManager) {
  const hasFeatureAccess = (featureFlag) => {
    if (plan.value.id === undefined) {
      return false;
    }
    if (betaPhaseManager.isInBeta.value) {
      return true;
    }

    if (subscriptionPastDue.value) {
      return plans.free.featureAccess[featureFlag];
    }

    return plans[plan.value.id].featureAccess[featureFlag];
  };
  return { hasFeatureAccess };
}
